import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { HttpStatusCodes } from 'app/shared/enums/http-statuscode.enum';
import { NotificationService } from 'app/shared/services';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ExceptionInterceptor implements HttpInterceptor {
  // Using inject(Injector) to lazily resolve dependencies and avoid circular dependency issues.
  // This approach ensures that the NotificationService is only instantiated when needed.
  private readonly injector = inject(Injector);

  public intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const errorMessage = this.getErrorMessage(error.status);
        const notificationSvc = this.injector.get(NotificationService);
        if (errorMessage) {
          notificationSvc.error(errorMessage);
        }
        return throwError(() => error);
      })
    );
  }

  private getErrorMessage(status: number): string | undefined {
    const errorMessages = new Map<number, string>([
      [HttpStatusCodes.Unauthorized, 'httpErrorCodes.unauthorized'],
      [HttpStatusCodes.Forbidden, 'httpErrorCodes.forbidden'],
      [HttpStatusCodes.ServiceUnavailable, 'httpErrorCodes.serviceUnavailable'],
      [
        HttpStatusCodes.InternalServerError,
        'httpErrorCodes.internalServerError',
      ],
    ]);

    return errorMessages.get(status);
  }
}
